site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0 && $owl.children().length > 1) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.attr('role', 'region').attr('aria-label', 'Flettiborði');
			$owl.owlCarousel($.extend({
				onInitialized: function() {
					$('.owl-nav div', $owl).attr('role', 'button');
					$('.owl-nav div:not(.disabled)', $owl).attr('tabindex', '0');
					$('.owl-nav .disabled', $owl).attr('tabindex', '-1');
					$('.owl-dot', $owl).attr('role', 'button').attr('tabindex', '-1');
					$('.owl-dot.active', $owl).attr('tabindex', '0');

					$(document.documentElement).keyup(function (e) {
						var target = $(e.target),
							action = null;

						if ($owl.length) {
							if (e.which === 13) {
								if (target.hasClass('owl-prev')) action = 'prev.owl.carousel';
								else if (target.hasClass('owl-next')) action = 'next.owl.carousel';
								else if (target.hasClass('owl-dot')) target.trigger('click');

								if (action) {
									$owl.trigger(action);
								}
							}
							else if (e.which === 37) {
								$owl.trigger('prev.owl.carousel');
								$('.owl-dot.active').focus();
							}
							else if (e.which === 39) {
								$owl.trigger('next.owl.carousel');
								$('.owl-dot.active').focus();
							}
						}
					});

					$owl.prepend('<a href="#" class="toggle playing" aria-label="Stoppa"></a>')

					$('.toggle', $owl).on('click', function(e) {
						e.preventDefault();
						var $this = $(this);
						if ($this.hasClass('playing')) {
							$owl.trigger('stop.owl.autoplay');
							$this.removeClass('playing').addClass('stopped');
							$this.attr('aria-label', 'Spila');
						}
						else {
							$owl.trigger('play.owl.autoplay', [8000])
							$this.removeClass('stopped').addClass('playing');
							$this.attr('aria-label', 'Stoppa');
						}
					});
				},

				onTranslated: function() {
					$('.owl-dot', $owl).attr('role', 'button').attr('tabindex', '-1');
					$('.owl-dot.active', $owl).attr('tabindex', '0');
					$('.owl-nav div:not(.disabled)', $owl).attr('tabindex', '0');
					$('.owl-nav .disabled', $owl).attr('tabindex', '-1');
				}
			}, options));
		}
	}
};
